import { render, staticRenderFns } from "./ReminderNotesContainerComponent.vue?vue&type=template&id=48fd9d2a&scoped=true"
import script from "./ReminderNotesContainerComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReminderNotesContainerComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ReminderNotesContainerComponent.vue?vue&type=style&index=0&id=48fd9d2a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fd9d2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48fd9d2a')) {
      api.createRecord('48fd9d2a', component.options)
    } else {
      api.reload('48fd9d2a', component.options)
    }
    module.hot.accept("./ReminderNotesContainerComponent.vue?vue&type=template&id=48fd9d2a&scoped=true", function () {
      api.rerender('48fd9d2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/ExpedientWidgets/ExpedientReminderNotes/ReminderNotesContainerComponent.vue"
export default component.exports